'use client';

import { useEffect, useState } from 'react';
import { avisoError } from '@/lib/avisoCentral';
import Login, { type Sesion } from './components/Login';
import AppShell from './components/AppShell';
import CambioObligatorio from './components/CambioObligatorio';
import PortalPublico from './views/PortalPublico';
import PortalAcceso from './views/PortalAcceso';

// Raíz de la app. Tres vistas posibles cuando NO hay sesión:
//  - 'login'  → formulario de ingreso (funcionarios y partes con login).
//  - 'portal' → Portal Ciudadano público (radicar queja / consultar estado).
// Cuando hay sesión (token en localStorage) se muestra el shell autenticado.
// La sesión se persiste para sobrevivir recargas.
export default function Page() {
  // Inicia sin sesión (así el servidor renderiza el Login). Tras montar, si hay
  // token guardado, restaura la sesión y pasa al shell.
  const [sesion, setSesion] = useState<Sesion | null>(null);
  // Vista pública activa mientras no hay sesión.
  const [vista, setVista] = useState<'login' | 'portal' | 'acceso'>('login');

  useEffect(() => {
    // Si venimos de un cierre de sesión por token expirado, avisar en el login.
    if (localStorage.getItem('sesion_expirada')) {
      localStorage.removeItem('sesion_expirada');
      avisoError('Su sesión expiró. Ingrese de nuevo.');
    }
    const token = localStorage.getItem('token');
    const usuario = localStorage.getItem('usuario');
    if (token && usuario) {
      try { setSesion(JSON.parse(usuario)); } catch { /* sesión corrupta: ignorar */ }
    }
  }, []);

  function salir() {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setSesion(null);
    setVista('login');
  }

  // Primer ingreso: antes del shell, obliga a cambiar la contraseña inicial.
  if (sesion && sesion.debeCambiarContrasena) {
    return (
      <CambioObligatorio
        usuario={sesion}
        onListo={() => setSesion({ ...sesion, debeCambiarContrasena: false })}
        onLogout={salir}
      />
    );
  }

  if (sesion) return <AppShell usuario={sesion} onLogout={salir} />;

  if (vista === 'portal') {
    return <PortalPublico onIngresar={() => setVista('login')} />;
  }

  // Portal externo de sujetos procesales (Orden 13): ingreso con correo + código.
  if (vista === 'acceso') {
    return <PortalAcceso onVolver={() => setVista('login')} />;
  }

  // El acceso al Portal Ciudadano se quitó del login (pedido del cliente); la
  // vista 'portal' se conserva por si se rehabilita con otra puerta de entrada.
  return <Login onLogin={setSesion} onAcceso={() => setVista('acceso')} />;
}
